import { createContext, useCallback, useRef, useState } from "react";
import { useResource } from "rest-hooks";
import { ThirdPartyScriptSettingsResource } from "@ploy-lib/rest-resources";
export const ThirdPartyScriptsContext = createContext({
    settings: {
        loadCookieBot: false,
        cookieBotId: "",
        loadGiosgChat: false,
        loadGoogleTagManager: false,
        googleTagManagerCode: "",
        googleTagManagerIncludeProduct: false,
        googleTagManagerIncludeObjectCategory: false,
        loadGoogleTagManagerExtended: false,
        loadZendeskChat: false,
        zendeskAccountKey: "",
        zendeskAlternativeAccountKey: "",
        loadDNBFIZendesk: false,
        loadZendeskOnLoginPage: true,
        loadSalesforceChat: false,
        salesforceOrgId: "",
        salesforceEmbeddedMessagingName: "",
        salesforceBaseUrl: "",
        salesforceScrt2Url: "",
        salesforceLanguage: "en_US"
    },
    google: {
        getHistory: () => [],
        push: (update) => { },
        pushAll: (id, update) => { },
        appendScript: false
    }
});
export const useThirdPartyScriptsContext = () => {
    const isInIframe = useRef(inIframe());
    const thirdPartySettings = useResource(ThirdPartyScriptSettingsResource.detail(), {});
    return {
        settings: {
            loadCookieBot: !isInIframe.current && thirdPartySettings.loadCookieBot,
            cookieBotId: thirdPartySettings.cookieBotId,
            // Giosg Chat
            loadGiosgChat: !isInIframe.current && thirdPartySettings.loadGiosgChat,
            //	GTM
            loadGoogleTagManager: thirdPartySettings.loadGoogleTagManager,
            googleTagManagerCode: thirdPartySettings.googleTagManagerCode,
            googleTagManagerIncludeProduct: thirdPartySettings.googleTagManagerIncludeProduct,
            googleTagManagerIncludeObjectCategory: thirdPartySettings.googleTagManagerIncludeObjectCategory,
            loadGoogleTagManagerExtended: thirdPartySettings.loadGoogleTagManagerExtended,
            //	Zendesk
            loadZendeskChat: !isInIframe.current && thirdPartySettings.loadZendeskChat,
            zendeskAccountKey: thirdPartySettings.zendeskAccountKey,
            zendeskAlternativeAccountKey: thirdPartySettings.zendeskAlternativeAccountKey,
            loadDNBFIZendesk: !isInIframe.current && thirdPartySettings.loadDNBFIZendesk,
            //	Salesforce Embedded Messaging
            loadSalesforceChat: !isInIframe.current && thirdPartySettings.loadSalesforceChat,
            salesforceOrgId: thirdPartySettings.salesforceOrgId,
            salesforceEmbeddedMessagingName: thirdPartySettings.salesforceEmbeddedMessagingName,
            salesforceBaseUrl: thirdPartySettings.salesforceBaseUrl,
            salesforceScrt2Url: thirdPartySettings.salesforceScrt2Url,
            salesforceLanguage: thirdPartySettings.salesforceLanguage
        },
        google: useGoogle(thirdPartySettings.loadGoogleTagManager)
    };
};
const useGoogle = (enabled) => {
    const isInIframe = useRef(inIframe());
    const [googleShadowHistory, setGoogleShadowHistory] = useState([]);
    const [googlePushOnce, setGooglePushOnce] = useState([]);
    const addGoogleShadowHistory = useCallback((update) => setGoogleShadowHistory([...googleShadowHistory, update]), [googleShadowHistory]);
    const hasGooglePushOnce = useCallback((id) => typeof googlePushOnce[id] === "string", [googlePushOnce]);
    const addGooglePushOnce = useCallback((id) => setGooglePushOnce([...googlePushOnce, id]), [googlePushOnce]);
    const postToParrent = useCallback((update) => {
        if (window.parent) {
            window.parent.postMessage(JSON.stringify({
                type: "googleTracking",
                update: update
            }), "*");
        }
    }, []);
    const getHistory = useCallback(() => {
        if (isInIframe.current) {
            return googleShadowHistory;
        }
        else {
            return window["dataLayer"] ?? [];
        }
    }, [googleShadowHistory]);
    const push = useCallback((update) => {
        if (isInIframe.current) {
            addGoogleShadowHistory(update);
            postToParrent(update);
        }
        else {
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push(update);
        }
    }, [addGoogleShadowHistory, postToParrent]);
    const pushAll = useCallback((id, update) => {
        if (!hasGooglePushOnce(id)) {
            if (isInIframe.current) {
                addGoogleShadowHistory(update);
                postToParrent(update);
            }
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push(update);
            addGooglePushOnce(id);
        }
    }, [
        addGooglePushOnce,
        addGoogleShadowHistory,
        hasGooglePushOnce,
        postToParrent
    ]);
    return {
        getHistory,
        push,
        pushAll,
        appendScript: enabled && !isInIframe.current
    };
};
function inIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
//# sourceMappingURL=ThirdPartyScriptsContext.js.map